function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Notification_Icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14.973v17.595H0z",
  "data-name": "Rectangle 175",
  style: {
    fill: "#fff"
  }
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.514 6)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  style: {
    fill: "#323232"
  },
  transform: "translate(-7.514 -6)"
}), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#Notification_Icon_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M94.828 298.575v.1a2.7 2.7 0 0 0 5.364 0v-.1z",
  "data-name": "Path 317",
  style: {
    fill: "#fff"
  },
  transform: "translate(-90.021 -283.448)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.58 10.146-.188-4.065v-.184a4.91 4.91 0 0 0-4.208-4.861V.717A.71.71 0 0 0 7.52 0a.7.7 0 0 0-.731.7v.339A4.91 4.91 0 0 0 2.576 5.9v.184l-.188 4.065a2.78 2.78 0 0 1-1.65 2.414l-.095.037a1.08 1.08 0 0 0-.643.993v.44a.326.326 0 0 0 .326.326h14.321a.326.326 0 0 0 .326-.326v-.44a1.08 1.08 0 0 0-.643-.988l-.095-.042a2.78 2.78 0 0 1-1.654-2.417",
  "data-name": "Path 318",
  style: {
    fill: "#fff"
  }
}))));
export { SvgNotificationIcon as ReactComponent };
export default __webpack_public_path__ + "images/Notification_Icon.710d8b34.svg";